import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e36e676"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bind-amazon-sku-content" }
const _hoisted_2 = { class: "bind-amazon-sku-title" }

import { t } from '@/plugins/i18n'
import CommonDialog from '@/components/common/CommonDialog.vue'
import ChooseAmazonSku from './ChooseAmzonSku.vue'
import BindSkuItem from './BindSkuItem.vue'
import { computed, ref } from 'vue'
import { bindAmazonSku } from '@/apis/inShipping'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { bindCrossMallSkuApi } from '@/apis/stock'

export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'item'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: emits }) {

const props = __props
const store = useStore()
const isCrossMall = computed(() => store.getters.isCrossMall)


const skuInfo: any = ref({})
const show = computed({
  get: () => props.visible,
  set: (val) => {
    emits('update:visible', val)
  }
})
const cancel = () => {
  emits('update:visible', false)
  skuInfo.value = {}
}
const getSku = (item: any) => {
  console.log(item)
  skuInfo.value = item
}
const ok = () => {
  if (isCrossMall.value ? !skuInfo.value.productSku : !skuInfo.value.amazonMsku) return
  const api = isCrossMall.value ? bindCrossMallSkuApi : bindAmazonSku
  const params = isCrossMall.value ? {
    crossMallSku: skuInfo.value.productSku,
    customerShopId: store.getters.curShop,
    shopProductSkuId: props.item.shopProductSkuId
  } : {
    amazonMsku: skuInfo.value.amazonMsku,
    shopProductSkuId: props.item.shopProductSkuId
  }
  api(params).then((res: any) => {
    if (res.success) {
      ElMessage.success(isCrossMall.value ? t('CROSS MALL sku绑定成功') : t('Amazon sku绑定成功'))
      emits('success', skuInfo.value, props.item)
      cancel()
    }
  })
}
const unbindSuccess = () => {
  emits('success', skuInfo.value, props.item)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonDialog, {
    onCancel: cancel,
    className: "kr-customs-tip",
    visible: _unref(show),
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(show) ? (show).value = $event : null)),
    width: 700,
    "append-to-body": "",
    "modal-class": "bind-amazon-sku-modal",
    "close-on-click-modal": false,
    title: _unref(isCrossMall) ? _unref(t)('绑定CROSS MALL sku') : _unref(t)('绑定Amazon sku'),
    footer: true,
    onOk: ok,
    disabled: _unref(isCrossMall) ? !skuInfo.value.productSku : !skuInfo.value.amazonMsku
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('当前商品绑定关系')), 1),
        _createVNode(BindSkuItem, {
          item: __props.item,
          onSuccess: unbindSuccess
        }, null, 8, ["item"]),
        (_unref(show))
          ? (_openBlock(), _createBlock(ChooseAmazonSku, {
              key: 0,
              onGetSku: getSku
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "title", "disabled"]))
}
}

})